import CTA from './CTA';
import React from 'react';
import { Link } from "react-router-dom";
import { arrow } from "../assets/icons";
import { projects } from '../constants';

function Project() {
  return (
    <section className='pt-24 mx-8 select-none'>
      <h1 className='font-bold text-3xl mb-6 text-indigo-900'>My <span className='text-semibold gradient-project tracking-widest'>Projects</span></h1>
      <div className='mb-10'> 
        <p className='text-xl tracking-wider font-semibold text-zinc-500 antialiased text-justify'>
            I've embarked on numerous projects throughout the years, but these are
            the ones I hold closest to my heart. Many of them are open-source, so if
            you come across something that piques your interest, feel free to
            explore the codebase and contribute your ideas for further enhancements.
            Your collaboration is highly valued!
        </p>

        <div className='flex flex-wrap my-20 gap-16'>
        {projects.map((project) => (
          <div className='lg:w-[400px] w-full' key={project.name}>
            <div className='block-container w-12 h-12'>
              <div className={`btn-back rounded-xl`} />
              <div className='rounded-xl flex justify-center items-center'>
                <img
                  src={project.iconUrl}
                  alt='threads'
                  className={project.name == "Decentralized Stablecoin Protocol" ? `object-cover h-14 w-14` : "object-contain"}
                />
              </div>
            </div>

            <div className='mt-5 flex flex-col'>
              <h4 className='text-2xl font-poppins font-semibold'>
                {project.name}
              </h4>
              <p className='mt-2 text-slate-500'>{project.description}</p>
              <div className='mt-5 flex items-center gap-2 font-poppins space-x-4'>
                {project.link == null ? '' :
                <Link
                  to={project.link}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='font-semibold text-cyan-600 tracking-wide text-sm'
                >
                  GitLink
                </Link>
                }
                {project.liveLink == null ? '' :
                <Link
                  to={project.liveLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='font-semibold flex justify-center items-center space-x-1 text-sm text-cyan-600'
                >
                  <p>Live Link</p>
                  <img
                    src={arrow}
                    alt='arrow'
                    className='w-2 h-2 object-contain'
                  />
                </Link>
                
                }
              </div>
            </div>
          </div>
        ))}
      </div>

      <hr className='border-slate-200' />

      <CTA />

      </div>
    </section>
  )
}

export default Project;